export const INTERPUNCT = '·';
